import React, { useEffect, useState } from "react";
import {
  ContactInfo,
  CustomerInfo,
  CustomerInfoNonIvf,
  CycleIq,
  Extras,
  MedicalDetails,
  MedicalDetailsIvf,
  MedicalDetailsNonIvf,
  PeriodInfo,
  PeriodInfotwo,
  options,
  periodoptions,
} from "./Utils/CustomerLabelInput";
import { HiOutlineChevronDoubleLeft } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import customer, {
  resetReducer,
  updateCustomerContactDetail,
  updateCustomerDetail,
  updateCustomerMedicalDetail,
  updateCycleIQDetail,
  updateperiod,
} from "../../../store/reducers/digitalmarketing/customer";
import {
  useAddCustomerMutation,
  useGetCustomerQuery,
  useUpdateCustomerMutation,
} from "../../../Service/customers";
import {
  useAddCustomerContactMutation,
  useGetCustomerContactQuery,
  useUpdateCustomerContactMutation,
} from "../../../Service/customerContact";
import {
  useAddCustomerMedicalMutation,
  useAddCustomerPeriodMutation,
  useAddCycleIqMutation,
  useGetCustomerCycleIQQuery,
  useGetCustomerMedicalQuery,
  useGetCustomerPeriodTrackerQuery,
  useUpdateCustomerMedicalMutation,
  useUpdateCycleIqMutation,
} from "../../../Service/customerMedical";
import { Button } from "@mui/material";
import { TbPlus } from "react-icons/tb";
import {
  useAddCustomerLogMutation,
  useGetCustomerLogByCustomerIdQuery,
} from "../../../Service/CustomerLogs";
import { useGetCustomerAppointmentByCustomerIdQuery } from "../../../Service/CustomerAppointment";
import { useGetCustomerJourneyByCustomerIdQuery } from "../../../Service/CustomerJourney";
import { useGetCustomerReminderByCustomerIdQuery } from "../../../Service/CustomerReminder";
import {
  emailValidation,
  negativeNumberStringValidation,
  specialChractorValidation,
  validatePhone,
  validationChecking,
  validationCheckingContact,
} from "./Utils/validation";
import SelectMenuItem from "./Component/SelectMenuItem";
import { formatDateString } from "./Utils";
import { useLocation, useParams } from "react-router-dom";

function CustomerDetails(props) {
  const {
    setshow,
    id,
    errorMessage,
    callBackforErrorMessage,
    openSnackBar,
    view,
  } = props;
  const { type } = useParams();
  const location = useLocation();
  const pathname = location.pathname;
  // const [errorMessage, setErrorMessage] = useState(false)
  const [comment, setComment] = useState("");
  const [error, setError] = useState();
  const Contact = useSelector((state: any) => state.customer.customerContact);

  const CustomerDetail = useSelector(
    (state: any) => state.customer.customerDetail
  );


  const CustomerMedical = useSelector(
    (state: any) => state.customer.customerMedical
  );
  const cycleIqDetails = useSelector(
    (state: any) => state.customer.cycleIqDetails
  );


  const customerPeriod = useSelector(
    (state: any) => state.customer.customerPeriod
  );
  // console.log(customerPeriod);

  const DashboardHealthIssues = useSelector(
    (state: any) => state.dashboard.healthIssues
  );

  const account = useSelector((state: any) => state.auth);

  // console.log(DashboardHealthIssues);
  const { data: customerPerio, isLoading: customerperiodLoading } =
    useGetCustomerPeriodTrackerQuery(id || "", {
      refetchOnMountOrArgChange: true,
    });
  // console.log("hi",customerPeriod);

  const { data: customerDetail, isLoading: customerLoading } =
    useGetCustomerQuery(id || "", { refetchOnMountOrArgChange: true });
  const { data: customerContact, isLoading: contactLoading } =
    useGetCustomerContactQuery(id || "", { refetchOnMountOrArgChange: true });
  const { data: customerMedical, isLoading: medicalLoading } =
    useGetCustomerMedicalQuery(id || "", { refetchOnMountOrArgChange: true });
  const { data: customerCycleIQ, isLoading: CycleIQLoading } =
    useGetCustomerCycleIQQuery(id || "", { refetchOnMountOrArgChange: true });
  const { data: customerLogs, isLoading: logsLoading } =
    useGetCustomerLogByCustomerIdQuery(id || "", {
      refetchOnMountOrArgChange: true,
    });
  const { data: customerAppointment, isLoading: appointmentLoading } =
    useGetCustomerAppointmentByCustomerIdQuery(id || "", {
      refetchOnMountOrArgChange: true,
    });
  const { data: customerJourney, isLoading: journeyLoading } =
    useGetCustomerJourneyByCustomerIdQuery(id || "", {
      refetchOnMountOrArgChange: true,
    });
  const { data: customerReminder, isLoading: reminderLoading } =
    useGetCustomerReminderByCustomerIdQuery(id || "", {
      refetchOnMountOrArgChange: true,
    });
  console.log(customerCycleIQ);

  const [updateCustomer] = useUpdateCustomerMutation();
  const [addCustomer] = useAddCustomerMutation();
  const [addCustomerLog, { isLoading: addLoading2 }] =
    useAddCustomerLogMutation();
  const [addCustomerContact, { isLoading: addLoading }] =
    useAddCustomerContactMutation();
  const [updateCustomerContact, { isLoading: updateLoading }] =
    useUpdateCustomerContactMutation();
  const [updateCustomerMedical, { isLoading: updateLoading1 }] =
    useUpdateCustomerMedicalMutation();
  const [addCustomerMedical, { isLoading: addLoading1 }] =
    useAddCustomerMedicalMutation();
  const [addCycleIq, { isLoading: addLoading4 }] =
    useAddCycleIqMutation();
  const [updateCycleIq, { isLoading: updateLoading4 }] =
    useUpdateCycleIqMutation();
  const [addCustomerPeriod, { isLoading: addLoading3 }] =
    useAddCustomerPeriodMutation();

  const dispatch = useDispatch();
  const loading =
    customerLoading ||
    contactLoading ||
    medicalLoading ||
    logsLoading ||
    appointmentLoading ||
    appointmentLoading ||
    reminderLoading;

  const saveCustomerDetails = async () => {


    let objects = { ...CustomerMedical, ...Contact, ...CustomerDetail, ...cycleIqDetails };
    let checking: any = validationChecking(objects, CustomerDetail);
    // let checking1: any = validationCheckingContact(Contact, Contact);
    // console.log(checking1);

    const contactDetailDublicte = { ...Contact };
    let check = true;
    Object.keys(Contact).map((item) => {
      if (item == "phone2" || item == "phone1") {
        contactDetailDublicte[item] = Number(contactDetailDublicte[item]);
      }
      if (item == "status") {
        contactDetailDublicte[item] = 1;
      }
    });

    if (
      CustomerDetail.customerName.trim().length &&
      !specialChractorValidation(CustomerDetail.customerName)
    ) {
      if (checking) {
        if (CustomerDetail.customerName.trim().length) {
          let dataobjects = {
            id: null,
            customerName: "",
            sex: "",
            spouseName: "",
            spouseAge: 0,
            spouseSex: "",
            yearsMarried: "",
            source: "",
            status: false,
            customerStatus: "",
            serviceChoosen: "",
            referredBy: "",
            occupation: "",
            dob: "",
            age:""
          };

          let data = {};

          // Iterate through the keys of dataobjects
          for (let key in dataobjects) {
            // Check if the key exists in CustomerDetail
            if (CustomerDetail.hasOwnProperty(key)) {
              // Add the key-value pair to the new object
              data[key] = CustomerDetail[key];
            }
          }

          // console.log(data);

          if (CustomerDetail.id) {
            await updateCustomer({
              id: CustomerDetail.id,
              ...data,
            });
          }
        } else {
          if (!CustomerDetail.customerName.trim().length) {
            openSnackBar(callBackforErrorMessage(), "error");
          }
        }
        if (true) {
          if (
            Contact.id &&
            contactDetailDublicte.phone1 &&
            contactDetailDublicte.phone1 != 0
          ) {
            if (Contact)
              await updateCustomerContact({
                id: contactDetailDublicte.id,
                ...contactDetailDublicte,
              });
          } else if (
            contactDetailDublicte.phone1 &&
            contactDetailDublicte.phone1 != 0
          ) {
            let value = { ...contactDetailDublicte };
            value.customerId = CustomerDetail.id;
            try {
              const payload = await addCustomerContact({
                ...value,
              }).unwrap();
            } catch (err: any) {
              check = false;
              openSnackBar(err?.data?.error, "error");
            }
          } else {
            openSnackBar("Enter Phone Number", "error");
            return;
          }
        }

        if (CustomerMedical.id) {
          updateCustomerMedical({
            id: CustomerDetail.id,
            ...CustomerMedical,
          });
        } else {
          let value = { ...CustomerMedical };
          value.customerId = CustomerDetail.id;

          addCustomerMedical({
            ...value,
          });
        }
        if (type === "fertility" && cycleIqDetails.id) {
          updateCycleIq({
            id: CustomerDetail.id,
            ...cycleIqDetails,
             comorbidities: typeof cycleIqDetails.comorbidities === 'string'
              ? cycleIqDetails.comorbidities.split(',').map(item => item.trim()) // remove extra spaces
              : Array.isArray(cycleIqDetails.comorbidities)
                ? cycleIqDetails.comorbidities
                : []
          });
        } else {
          let value = { ...cycleIqDetails };
          value.customerId = CustomerDetail.id;

          addCycleIq({
            ...value,
            comorbidities: typeof value.comorbidities === 'string'
              ? value.comorbidities.split(',').map(item => item.trim()) // remove extra spaces
              : Array.isArray(value.comorbidities)
                ? value.comorbidities
                : []
          });

        }
        if (
          type === "fertility" &&
          customerPeriod.mensturalCycle === "regular"
        ) {
          if (
            customerPeriod.cycleLength !== null &&
            customerPeriod.lastPeriod !== null &&
            customerPeriod.ovulationDate !== null
          ) {
            let dataobjects = {
              id: null,
              userId: "",
              mensturalCycle: "regular",
              avgPeriodLength: "",
              cycleLength: null,
              lastPeriod: null,
              ovulationDate: null,
            };
            let data = {};

            for (let key in dataobjects) {
              // Check if the key exists in CustomerDetail
              if (customerPeriod.hasOwnProperty(key)) {
                // Add the key-value pair to the new object
                data[key] = customerPeriod[key];
              }
            }
            try {
              const payload = await addCustomerPeriod({
                ...data,
              }).unwrap();
            } catch (err: any) {
              check = false;
              openSnackBar(err?.data?.message, "error");
            }
          } else {
            console.log(customerPeriod.cycleLength);

            if (customerPeriod.lastPeriod === null) {
              openSnackBar("Fill lastPeriod", "error");
              check = false;
            } else if (customerPeriod.ovulationDate === null) {
              openSnackBar("Fill ovulationDate", "error");
              check = false;
            }
          }
        } else if (
          type === "fertility" &&
          customerPeriod.mensturalCycle === "irregular"
        ) {
          if (
            customerPeriod.cycleLength !== null &&
            customerPeriod.lastPeriod !== null
          ) {
            let dataobjects = {
              id: null,
              userId: "",
              mensturalCycle: "regular",
              cycleLength: null,
              lastPeriod: null,
              periodFlow: "",
              ideaAboutCycle: "",
            };
            let data = {};

            for (let key in dataobjects) {
              // Check if the key exists in CustomerDetail
              if (customerPeriod.hasOwnProperty(key)) {
                // Add the key-value pair to the new object
                data[key] = customerPeriod[key];
              }
            }

            try {
              const payload = await addCustomerPeriod({
                ...data,
              }).unwrap();
            } catch (err: any) {
              check = false;
              openSnackBar(err?.data?.message, "error");
            }
          } else {
            if (customerPeriod.lastPeriod === null) {
              check = false;

              openSnackBar("Fill lastPeriod", "error");
            }
          }
        }
        check && openSnackBar("successfully saved", "success");
      }
    } else {
      openSnackBar(callBackforErrorMessage(), "error");
    }
  };
  useEffect(() => {
    console.log(customerPeriod);
  }, [customerPeriod]);

  const handleChangesetmedical = (event, names) => {
    if (
      CustomerDetail.id &&
      CustomerDetail.customerName.trim().length &&
      !specialChractorValidation(CustomerDetail?.customerName)
    ) {
      if (names === "lmp") {
        dispatch(
          updateCustomerMedicalDetail({
            [names]: event,
          })
        );
      } else
        dispatch(
          updateCustomerMedicalDetail({
            [event.target.name]: event.target.value,
          })
        );
    } else {
      openSnackBar(callBackforErrorMessage(), "error");
    }
  };

  const handleChangeseIQ = (event, name) => {
    const { value } = event.target;
    if (
      CustomerDetail.id &&
      CustomerDetail.customerName.trim().length &&
      !specialChractorValidation(CustomerDetail?.customerName)
    ) {
      dispatch(
        updateCycleIQDetail({
          [name]: value,
        })
      );
    } else {
      openSnackBar(callBackforErrorMessage(), "error");
    }
  };


  const handleChangeInfo = (event, validation) => {
    const { name, value } = event.target;
    if (
      CustomerDetail.id &&
      CustomerDetail.customerName.trim().length &&
      !specialChractorValidation(CustomerDetail?.customerName)
    ) {
      dispatch(
        updateCustomerContactDetail({
          [name]: value,
        })
      );
    } else {
      openSnackBar(callBackforErrorMessage(), "error");
    }
  };
  const handlePeriodInfo = (event, names) => {
    if (names === "lastPeriod") {
      console.log(event);

      dispatch(
        updateperiod({
          [names]: formatDateString(event),
        })
      );
    } else if (names === "ovulationDate") {
      // console.log(event);

      dispatch(
        updateperiod({
          [names]: formatDateString(event),
        })
      );
    } else if (CustomerDetail.id) {
      const { name, value } = event.target;
      dispatch(
        updateperiod({
          [name]: value,
        })
      );
    } else {
      openSnackBar(callBackforErrorMessage(), "error");
    }
  };
  const handlePeriodInfoType = (event) => {
    const { name, value } = event.target;
    if (CustomerDetail.id) {
      dispatch(
        updateperiod({
          mensturalCycle: value,
          cycleLength: null,
        })
      );
    } else {
      openSnackBar(callBackforErrorMessage(), "error");
    }
  };
  const getLabelByValue = (obj, value) => {
    let val = obj.find((item) => item.value == value);

    if (val) {
      return val.label;
    }
    return "";
  };
  // val.label.charAt(0).toUpperCase() + val.label.slice(1).toLowerCase();
  const getValueByLabel = (obj, label) => {
    // console.log(label);

    let val = obj.find((item) => item.label == label && label);
    // console.log(val);
    if (val) {
      return val.value;
    }
    return "";
  };
  const handleChangeData = (e, validation) => {
    setError(validation);
    // console.log(e.target.value);
    // console.logg(getLabelByValue(options, e.target.value));

    // console.log(e.target.name);
    // console.log(!specialChractorValidation(CustomerDetail?.customerName));
    // console.log(CustomerDetail.customerName.trim().length);
    // console.log(CustomerDetail.id);
    // console.log(e.target.name === "source");

    callBackforErrorMessage(false);
    console.log(CustomerDetail.id, " CustomerDetail.id");
    if (
      CustomerDetail.id &&
      CustomerDetail.customerName.trim().length &&
      !specialChractorValidation(CustomerDetail?.customerName)
    ) {
      if (e.target.name === "source") {
        dispatch(
          updateCustomerDetail({
            [e.target.name]: getLabelByValue(options, e.target.value),
            leadType: type,
          })
        );
      } else {
        // console.log(e.target.value,'e.target.value 33',e.target.name)
        dispatch(
          updateCustomerDetail({
            [e.target.name]: e.target.value,
            leadType: type,
          })
        );
      }
    } else {
      if (e.target.name != "customerName" && !CustomerDetail.id) {
        openSnackBar(callBackforErrorMessage(), "error");
      } else {
        if (e.target.name == "customerName") {
          dispatch(
            updateCustomerDetail({
              [e.target.name]: e.target.value,
              leadType: type,
            })
          );
        } else {
          if (CustomerDetail.customerName.trim().length) {
            console.log(e.target.value, "e.target.value");
            dispatch(
              updateCustomerDetail({
                [e.target.name]: e.target.value,
                leadType: type,
              })
            );
          } else {
            openSnackBar(callBackforErrorMessage(), "error");
          }
        }
      }
    }
  };

  const onEnterUsername = (e) => {
    if (!specialChractorValidation(e.target.value)) {
      if (!CustomerDetail.id && CustomerDetail.customerName.trim().length) {
        addCustomer({
          [e.target.name]: e.target.value,
          leadType: type,
        });
      } else {
        if (CustomerDetail.customerName.trim().length) {
          updateCustomer({
            id: CustomerDetail.id,
            [e.target.name]: e.target.value,
          });
        } else {
          openSnackBar(callBackforErrorMessage(), "error");
        }
      }
    } else {
      // callBackforErrorMessage()
      openSnackBar(callBackforErrorMessage(), "error");
    }
  };

  const addClassForMoz = (a) => {
    const checking = a.name == "spouseHealthIssues";
    return checking;
  };
  // console.log(CustomerDetail);

  const userNameValidation = () => {
    if (specialChractorValidation(CustomerDetail?.customerName)) {
      return "special character not allowed in this field";
    } else if (!CustomerDetail?.customerName.length) {
      return "Please enter the patient name...!";
    }
  };



  const renderComp = () => {
    const Conitems = [
      { id: 1, name: "Diabetes", value: "diabetes" },
      { id: 2, name: "Hypertension", value: "hypertension" },
      { id: 3, name: "Thyroid Disorder", value: "thyroid" },
      { id: 4, name: "Asthma", value: "asthma" },
    ]
    return (
      <>
        <li>
          <input
            type="text"
            disabled={view}
            placeholder="Enter patient name *"
            name="customerName"
            value={CustomerDetail?.customerName}
            onChange={(event) => handleChangeData(event, null)}
            onBlur={onEnterUsername}
            className={`text-custom-title ${errorMessage && "errorMessage"}`}
          />
          {errorMessage && (
            <p>
              <span style={{ color: "red", fontSize: 12 }}>
                {userNameValidation()}
              </span>
            </p>
          )}
          <HiOutlineChevronDoubleLeft
            className="left-details"
            onClick={() => setshow(true)}
          />
        </li>
        {type === "general" &&
          CustomerInfoNonIvf.map((a, i) => (
            <li className="input-custom" key={i}>
              <a.tag
                view={view}
                {...CustomerDetail}
                img={a.img}
                label={a.label}
                name={a.name}
                handleChange={handleChangeData}
                validation={a.name === "dob" ? "date" : a.validation}
              // onBlur={(event) => onBlur(event, "CustomerInfo")}
              />
            </li>
          ))}
        {console.log(CustomerDetail, "CustomerDetail")}
        {type === "fertility" &&
          CustomerInfo.map((a, i) => (
            <li className="input-custom" key={i}>
              <a.tag
                view={view}
                {...CustomerDetail}
                img={a.img}
                label={a.label}
                name={a.name}
                validation={a.validation}
                handleChange={handleChangeData}
              // onBlur={(event) => onBlur(event, "CustomerInfo")}
              />
            </li>
          ))}
        <span className="d-flex justify-content-between">
          <div>
            <span className="det-label mb-1">Source</span>
          </div>
          <div className="d-flex justify-content-start">
            <SelectMenuItem
              styles={"select"}
              name="source"
              view={view}
              option={options}
              value={getValueByLabel(options, CustomerDetail.source)}
              onChange={handleChangeData}
              width={150}
            />
          </div>
        </span>

        <li>
          <p className="mt-2 mb-1 f-20 fw-500 fw-bold">Contact information</p>
        </li>
        {console.log(Contact, "Contact")}
        {ContactInfo.map((a, i) => {
          return (
            <li className="input-custom" key={i}>
              <a.tag
                {...Contact}
                img={a.img}
                error={error}
                view={view}
                label={a.label}
                name={a.name}
                validation={a.validation}
                handleChange={handleChangeInfo}
              />
            </li>
          );
        })}

        <li>
          <p className="f-20 fw-500 fw-bold mt-2 mb-1 ">Medical Details</p>
        </li>

        {type === "general" &&
          MedicalDetailsNonIvf.map((a, i) => (
            <li
              className={`input-custom ${a.name == "lmp" ? "d-flex" : addClassForMoz(a)
                }`}
              key={i}
            >
              <a.tag
                {...CustomerMedical}
                {...a}
                view={view}
                callBackforErrorMessage={callBackforErrorMessage}
                items={DashboardHealthIssues}
                handleChange={handleChangesetmedical}
              />
            </li>
          ))}
        {/* {type === "fertility" && (
          <li className="input-custom">
            <span className="det-label">
              <img
                src={require(`../../../assets/DigitalMarketing/image/customer/inject.png`)}
                alt="i"
              />{" "}
              Previous ART treatments
            </span>
          </li>
        )} */}
        {type === "fertility" &&
          MedicalDetailsIvf.map((a, i) => (
            <li
              className={`input-custom ${a.name == "lastperiod" ? "d-flex" : addClassForMoz(a)
                }`}
              key={i}
            >
              <a.tag
                {...CustomerMedical}
                {...a}
                view={view}
                callBackforErrorMessage={callBackforErrorMessage}
                items={DashboardHealthIssues}
                handleChange={(event) => handleChangesetmedical(event, a.name)}
              />
            </li>
          ))}

        <li>
          <p className="f-20 fw-500 fw-bold mt-2 mb-1 ">Cycle IQ</p>
        </li>
        {type === "fertility" &&
          CycleIq.map((a, i) => (
            <li
              className={`input-custom ${a.name == "lastperiod" ? "d-flex" : addClassForMoz(a)
                }`}
              key={i}
            >
              <a.tag
                {...cycleIqDetails}
                {...a}
                view={view}
                name={a.name}
                callBackforErrorMessage={callBackforErrorMessage}
                items={Conitems}
                handleChange={(event) => handleChangeseIQ(event, a.name)}
              />
            </li>
          ))}
        <br />

        {/* {type === "fertility" && (
          <>
            <span className="title mb-1">Menstrual cycle types</span>

            <SelectMenuItem
              styles={"select"}
              name="Menstural cycle Type"
              view={view}
              option={periodoptions}
              value={customerPeriod?.mensturalCycle}
              onChange={handlePeriodInfoType}
            />
            {customerPeriod?.mensturalCycle === "regular" &&
              PeriodInfo.map((a, i) => (
                <li
                  className={`input-custom ${
                    a.name === "lastPeriod"
                      ? "d-flex"
                      : a.name === "ovulationDate"
                      ? "d-flex"
                      : addClassForMoz(a)
                  }`}
                  key={i}
                >
                  <a.tag
                    {...customerPeriod}
                    img={a.img}
                    error={error}
                    view={view}
                    label={a.label}
                    name={a.name}
                    validation={a.validation}
                    handleChange={handlePeriodInfo}
                  />
                </li>
              ))}
            {customerPeriod?.mensturalCycle === "irregular" &&
              PeriodInfotwo.map((a, i) => (
                <li
                  className={`input-custom ${
                    a.name == "lastPeriod" ? "d-flex" : addClassForMoz(a)
                  }`}
                  key={i}
                >
                  {a.name !== "periodFlow" ? (
                    a.name !== "cycleLength" ? (
                      <a.tag
                        {...customerPeriod}
                        img={a.img}
                        error={error}
                        view={view}
                        label={a.label}
                        name={a.name}
                        validation={a.validation}
                        handleChange={handlePeriodInfo}
                      />
                    ) : (
                      <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <span className="title mb-1">{a.label}</span>
                        <SelectMenuItem
                          styles={"select available-content"}
                          name={a.name}
                          view={view}
                          option={a.options}
                          value={customerPeriod[a.name]}
                          onChange={handlePeriodInfo}
                        />
                      </div>
                    )
                  ) : (
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                      <span className="title mb-1">{a.label}</span>
                      <SelectMenuItem
                        styles={"select available-content"}
                        name={a.name}
                        view={view}
                        option={a.options}
                        value={customerPeriod[a.name]}
                        onChange={handlePeriodInfo}
                      />
                    </div>
                  )}
                </li>
              ))}
          </>
        )} */}
        {/* <li>
          <p className="title mt-2 mb-1">Extras</p>
        </li> */}
        {/* {Extras.map((a, i) => (
          <li className="input-custom" key={i}>
            <a.tag
              {...CustomerMedical}
              img={a.img}
              view={view}

              label={a.label}
              name={a.name}
              value="ds"
              handleChange={handleChangesetmedical}
            />
          </li>
        ))} */}
        <div style={{ textAlign: "center" }} className="mt-3">
          {!view && (
            <Button
              onClick={() => {
                saveCustomerDetails();
              }}
              variant="contained"
              style={{ float: "none", width: "max-content" }}
              id="btn-blue"
              disabled={
                view ||
                updateLoading ||
                addLoading ||
                updateLoading1 ||
                addLoading1 ||
                addLoading3 ||
                addLoading4
              }
            >
              {updateLoading ||
                addLoading ||
                updateLoading1 ||
                addLoading1 ||
                addLoading3 ||
                addLoading4
                ? "Please Wait"
                : CustomerDetail.id
                  ? "Update"
                  : "Save"}
            </Button>
          )}
        </div>
        {/* <input
        className="inp"
        placeholder="Type your own (Hit tab to add your custom label)"
      /> */}
        <label className="det-label">Notes</label>
        <br></br>
        <textarea
          className="text-area"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={3}
          disabled={view}
          placeholder="Add Notes here"
        />
        <div
          style={{
            paddingTop: "12px",
            paddingRight: "10px",
            paddingBottom: "12px",
            paddingLeft: "10px",
            backgroundColor: "#F2F3F5",
            borderRadius: "8px",
            marginTop: "5px",
          }}
        >
          <p style={{ fontSize: "14px" }}>
            Looks like it's your first time talking to this customer
          </p>
          {!view && (
            <Button
              onClick={() => {
                if (
                  CustomerDetail.customerName.trim().length &&
                  !specialChractorValidation(CustomerDetail.customerName)
                ) {
                  if (CustomerDetail.id) {
                    addCustomerLog({
                      customerId: CustomerDetail.id,
                      medium: "Dashboard",
                      status: "Created",
                      comments: comment,
                    });
                    setComment("");
                  } else {
                    openSnackBar("Please add notes before submit!", "error");
                  }
                } else {
                  openSnackBar(callBackforErrorMessage(), "error");
                }
              }}
              variant="contained"
              className="mozz-button"
              disabled={view || addLoading2}
              style={{ float: "none", width: 94 }}
              id="btn-blue"
            >
              <TbPlus />
              &nbsp;{addLoading2 ? "wait" : "Log this"}
            </Button>
          )}
        </div>
      </>
    );
  };
  return (CustomerDetail?.id || !loading) && <>{renderComp()}</>;
}

export default CustomerDetails;
